import styled from 'styled-components';
import { Color } from '../../config/Color';
import { appOverride } from '../../util/AppUtils';
import { bodyFontStyle } from './Typography';

export const DobNumberInput = styled.input<{
  width: number;
  marginLeft?: number;
}>`
  width: ${({ width }) => width}px;
  height: 48px;
  ${bodyFontStyle};

  &,
  &:focus,
  &:hover {
    border: none;
    box-shadow: none;
    text-align: left;
    background: transparent;
    appearance: textfield;
    padding: 0;
    margin-left: ${({ marginLeft }) => marginLeft ?? 0}px;
  }

  &:focus,
  &:focus-within {
    border-color: ${Color.flow.accent};
  }

  &::placeholder {
    color: ${appOverride({ nerva: '#f5f5f5', default: Color.content.default })};
    opacity: 0.25;
  }
`;
